import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { pages } from '../config/site';
export default function Metadata() {
  const {
    pathname: locationPathname,
    hash
  } = useLocation();
  const pathname = locationPathname.replace(/\/+$/, '') || '/';
  useEffect(() => {
    if (hash === "#formulario") document.getElementById("formulario")?.scrollIntoView?.();else window.scrollTo(0, 0);
  }, [pathname, hash]);
  useEffect(() => {
    const [title, description] = pages[pathname] || ['CoffeeIn Club', 'Descubra cafeterias com o CoffeeIn Club.'];
    const legacy = !pages[pathname];
    for (const href of ['/css/bootstrap.css', '/fonts/font-awesome/css/font-awesome.css', '/css/style.css']) {
      let sheet = document.head.querySelector(`link[data-legacy="${href}"]`);
      if (legacy && !sheet) {
        sheet = document.createElement('link');
        sheet.rel = 'stylesheet';
        sheet.href = href;
        sheet.dataset.legacy = href;
        document.head.appendChild(sheet);
      }
      if (!legacy && sheet) sheet.remove();
    }
    document.title = title;
    document.documentElement.lang = 'pt-BR';
    const meta = (key, value, property = false) => {
      const attr = property ? 'property' : 'name';
      let el = document.head.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.content = value;
    };
    meta('description', description);
    meta('og:title', title, true);
    meta('og:description', description, true);
    meta('og:url', `https://coffeein.club${pathname}`, true);
    meta('og:type', 'website', true);
    meta('og:image', 'https://coffeein.club/img/coffeeinclub.png', true);
    meta('twitter:card', 'summary_large_image');
    meta('twitter:title', title);
    meta('twitter:description', description);
    meta('robots', pages[pathname] ? 'index,follow' : 'noindex,follow');
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement('link');
      link.rel = 'canonical';
      document.head.appendChild(link);
    }
    link.href = `https://coffeein.club${pathname}`;
  }, [pathname]);
  return null;
}
